import React from 'react';
import './SecondPage.css';
import PieCard from './PieCard';
import SuspectedTable from "./SuspectedTable";
import {
    Flex,
    Heading,
    Text,
    SimpleGrid,
    useColorModeValue,
} from "@chakra-ui/react";
import { Highlight } from "rough-notation";

const SecondPage = (props) => {
    const { topSuspectedBrands,
        topSuspectedSellers,
        topInfringingPlatforms } = props;

    const textColor = useColorModeValue("secondaryGray.900", "white");

    return (
        <div className="second-page">
            <Heading fontSize='24px' mb='10px'>
                <Flex paddingBottom='10px' justify='space-between' align='center'>
                    <Text
                        color={textColor}
                        lineHeight='100%'
                        m='auto'
                        className="heading1"
                    >
                        OVERVIEW

                    </Text>
                </Flex>
            </Heading>
            <Flex px='10px' paddingBottom='20px' justify='space-between' align='center'>
                <Text
                    color={textColor}
                    lineHeight='100%'
                    m='auto'
                    className="heading2"
                >
                    
                    Top Suspected Brands
                </Text>
            </Flex>
            <SimpleGrid columns="2" gap='10px' mb='50px'>
                <SuspectedTable finalData={topSuspectedBrands} heading="Brands" />
                <PieCard finalData={topSuspectedBrands} />
            </SimpleGrid>
            <Flex px='10px' paddingBottom='20px' justify='space-between' align='center'>
                <Text
                    color={textColor}
                    lineHeight='100%'
                    m='auto'
                    className="heading2"
                >
                    Top Suspected Sellers
                </Text>
            </Flex>
            <SimpleGrid columns='2' gap='10px' mb='50px'>
                <SuspectedTable finalData={topSuspectedSellers} heading="Sellers" />
                <PieCard finalData={topSuspectedSellers} />
            </SimpleGrid>
            <Flex px='10px' pb='20px' justify='center' align='center'>
                <Text
                    color={textColor}
                    lineHeight='100%'
                    className="heading2"
                >
                    Top Infringing Platforms
                </Text>
            </Flex>

            <SimpleGrid columns="2" gap='10px' mb='50px'>
                <SuspectedTable finalData={topInfringingPlatforms} heading="Platforms" />
                <PieCard finalData={topInfringingPlatforms} />
            </SimpleGrid>
        </div>
    );
};

export default SecondPage;
